import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=2bd0882c&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=2bd0882c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0882c",
  null
  
)

export default component.exports